import axios from '@/lib/axios'
const user = {
    state: {
        uid: '', // 用户id
        realName: '', // 真实姓名
        mobile:'', // 手机号
        talent_org_id:'', // 人才库id
        username: '', // 用户名
        is_govern: '', // 1 工作单位 2主管单位
    },
    getters: {
    },
    mutations: {
        setUserInfo(state, info) {
            state.uid = info.uid;
            state.realName = info.realname;
            state.mobile = info.mobile;
            state.talentOrgId = info.talent_org_id;
            state.username = info.username;
            state.is_govern = info.is_govern;
        }
    },
    actions: {
        getUserInfo(store) {
            return new Promise((resolve, reject) => {
                axios.get('/webapi/web/loginuserinfo')
                    .then(res => {
                        let data = res.data;
                        if (data.code === 200) {
                            store.commit('setUserInfo', data.data);
                            resolve();
                        } else {
                            reject(new Error('获取用户信息失败'))
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        reject(err);
                    });
            })
        }
    }
}

export default user;
